import { useTranslation } from 'react-i18next';
import TrendLineChart from '../../Trends/components/TrendLineChart'
import TrendBarChart from '../../Trends/components/TrendBarChart';

const SenpilicTrendChartFactory = (props) => {
    const { data, timeAggType, currencySymbol, graphTypes } = props;
    const {t} = useTranslation()
    
    return (
        <>
        {[
            "COGENERATION",
            "POWER_METER",
            "GAS_METER",
            "ELECTRICITY_CONSUMPTION",
            "TRANSFORMER",
        ].filter(d => graphTypes.includes(d)).map((graphType) => (
        <TrendLineChart graphType={graphType}
            data={data}
            timeAggType={timeAggType}
            currencySymbol={currencySymbol}
            key={`graph-${graphType}`}/>)) }
        {[
            "ENERGY_PRICE", 
            "CARBON_INTENSITY",
            
        ].filter(d => graphTypes.includes(d)).map((graphType) => ( <TrendBarChart graphType={graphType}
        data={data}
        timeAggType={timeAggType}
        currencySymbol={currencySymbol}
        key={`graph-${graphType}`}/>))}
        </> 
     );
}
 
export default SenpilicTrendChartFactory;